<ndc-dynamic [ndcDynamicComponent]="autocompleterComponent()"
             [ndcDynamicInputs]="{ availableValues: valueOptions,
                                   appendTo: appendTo,
                                   resource: this.resource,
                                   model: selectedOption ? selectedOption : '',
                                   required: required,
                                   disabled: inFlight,
                                   id: handler.htmlId,
                                   finishedLoading: true,
                                   classes: 'inline-edit--field ' + handler.fieldName,
                                   showAddNewButton: showAddNewButton }"
             [ndcDynamicOutputs]="referenceOutputs">
</ndc-dynamic>
